module.exports = __webpack_public_path__ + "img/1561841179.08a45120.jpg";